import { EventEmitter } from "@angular/core";
import { SharedDataService } from "../../../all-services";
import { forkJoin } from "rxjs";

export class detailSupplierScreenValidity {
    private _isValid: boolean = null;
    public get isValid(): boolean{
        return this._isValid;
    }
    public set isValid(value :boolean) {
        this.validationPending = (value==null);
        if (this._isValid != value) {
            this._isValid = value; 
            if(value!=null) {
                this.validationChange.emit(value);
            }
        }
    }
    public step: number;
    public validationPending: boolean = false;
    public errorMessages:string[] = [];
    public validationChange:EventEmitter<boolean>= new EventEmitter<boolean>();
    constructor(
        public sharedDatasSvc:SharedDataService,
        numStep?:number){
        this.step = numStep||0;
        this.validationPending = false;
    }

    

    showErrors(afterShown:()=>any = null){
        if (this.errorMessages.length==0) {
            if (afterShown) afterShown();
            return;
        }
        forkJoin(
            this.errorMessages.map(lblCod=>this.sharedDatasSvc.getLabel(lblCod))
        ).subscribe({
            next:(traductions:string[])=>this.sharedDatasSvc.alert(traductions.join('<BR />'),afterShown, 'error')
            });
      }
}